import { useTranslation } from 'react-i18next';
import { Button } from '@teo/components';
import {
  OpenExternalLink,
  Person,
  Location,
  City,
} from '@teo/components/icons';
import { useEffect } from 'react';

export const TrainingLearnInfo = ({ training, persons, institution }: any) => {
  const { t } = useTranslation();

  const handleScroll = () => {
    const scrollSection = document.getElementById('details-section-training');
    const footer = document.getElementById('footer_page');
    const scrollY = window.scrollY;
    if (scrollSection) {
      if (scrollY < 81) {
        scrollSection.style.marginTop = 80 - scrollY + 'px';

        const heightTop = 80 - scrollY;
        scrollSection.style.maxHeight = `calc(100vh - ${heightTop}px)`;
      } else {
        scrollSection.style.marginTop = '0px';
        scrollSection.style.maxHeight = `calc(100vh)`;
      }
    }
    if (footer) {
      const rect = footer.getBoundingClientRect();
      const windowHeight = window.innerHeight;

      const isVisible = rect.top < windowHeight && rect.bottom > 0;

      let visible = 0;
      if (isVisible && scrollSection) {
        const visibleTop = Math.max(rect.top, 0);
        const visibleBottom = Math.min(rect.bottom, windowHeight);
        visible = visibleBottom - visibleTop;
        if (scrollY > 80) {
          scrollSection.style.maxHeight = `calc(100vh - ${visible - 1}px)`;
        } else {
          scrollSection.style.maxHeight = `calc(100vh - ${
            visible - 1 + 80 - scrollY
          }px)`;
        }
      }
    }
  };

  useEffect(() => {
    handleScroll();
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <div className="ml-4 min-w-[320px] xl:min-w-[430px]">
      <div
        id="details-section-training"
        className="fixed -top-[1px] right-0 z-0 mt-[80px] flex h-full max-h-[calc(100vh_-_150px)] w-full max-w-[320px] flex-col overflow-y-auto border bg-white xl:max-w-[430px]"
      >
        <div className="flex flex-col">
          {training?.url && training?.typeOfTraining !== 'internal' && (
            <div className="flex flex-col p-8">
              <p className="pb-2 text-base font-medium text-grey-06">
                {t('pages.landing_training.subscription')}
              </p>
              <p className="text-sm text-grey-08">
                {t('pages.landing_training.subscription_text')}
              </p>
              <div className="mt-6">
                <Button
                  variant="outline"
                  className="flex items-center"
                  onClick={() => window.open(training?.url)}
                >
                  {t('pages.landing_training.subscription_btn')}
                  <OpenExternalLink className="ml-1 h-4 w-4 text-grey-04" />
                </Button>
              </div>
            </div>
          )}

          {persons?.length > 0 && training?.typeOfTraining !== 'online' && (
            <div className="flex flex-col border-t p-8">
              <p className="pb-2 text-base font-medium text-grey-06">
                {t('pages.landing_training.contact')}
              </p>
              {persons?.map((person: any) => {
                return (
                  <div
                    key={person?.id + '_' + person?.trainingId}
                    className="mb-2 flex rounded-lg border border-grey-02 p-4"
                  >
                    <div className="flex flex-col gap-2">
                      <div className="flex w-full">
                        <Person className="h-5 w-5" />
                      </div>

                      <h4>{person?.contactName}</h4>
                      <a
                        className="text-sm text-[#1173DD]"
                        href="mailto:info@teo.training"
                      >
                        {person?.contactEmail}
                      </a>
                      <p className="text-sm text-[#1E1E20A8]">
                        {person?.contactPhone}
                      </p>
                    </div>
                  </div>
                );
              })}
            </div>
          )}
          {training?.location && training?.typeOfTraining !== 'online' && (
            <div className="flex flex-col border-t p-8">
              <p className="pb-2 text-base font-medium text-grey-06">
                {t('pages.landing_training.location')}
              </p>
              <div className="mb-2 flex rounded-lg border border-grey-02 p-4">
                <div className="flex flex-col gap-2">
                  <div className="flex w-full">
                    <Location className="h-5 w-5" />
                  </div>
                  <h4 className="whitespace-pre-line">{training?.location}</h4>
                  <a
                    className="text-sm text-[#1173DD]"
                    href={`https://www.google.com/maps?q=${encodeURIComponent(
                      training?.location?.replace(/\n/g, ' ')
                    )}`}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {t('pages.landing_training.get_directions')}
                  </a>
                </div>
              </div>
            </div>
          )}
          {institution && training?.typeOfTraining === 'external' && (
            <div className="flex flex-col border-t p-8">
              <p className="pb-2 text-base font-medium text-grey-06">
                {t('pages.landing_training.institution')}
              </p>

              <div className="mb-2 flex rounded-lg border border-grey-02 p-4">
                <div className="flex flex-col gap-2">
                  <div className="flex w-full">
                    <City className="h-5 w-5" />
                  </div>

                  <h4>{institution?.contactName}</h4>
                  <a
                    className="text-sm text-[#1173DD]"
                    href="mailto:info@teo.training"
                  >
                    {institution?.contactEmail}
                  </a>
                  <p className="text-sm text-[#1E1E20A8]">
                    {institution?.contactPhone}
                  </p>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TrainingLearnInfo;
